<template>
  <v-row no-gutters style="max-height: 68px !important">
    <v-col style="max-height: 24px">
      <v-row no-gutters justify="end" align="center" class="mr-2">
        <div
          style="min-width: 50px"
          class="d-flex flex-row align-center justify-center newSectionStyle"
        >
          <span
            class="d-flex justify-center mr-1"
            :class="{
              'textType--text': !$vuetify.theme.dark,
              textColor: $vuetify.theme.dark,
            }"
            >{{ $t('message.ai.activationPrice') }}
          </span>
          <img src="@/assets/credit_small_icon.svg" />

          <span
            v-if="!creditsLoading"
            class="pl-1 mainText"
            :class="{
              'textType--text': !$vuetify.theme.dark,
              textColor: $vuetify.theme.dark,
            }"
          >
            {{ activationPrice }}
          </span>
          <v-skeleton-loader
            v-else
            class="rounded"
            type="chip"
            height="20"
            width="40"
            tile
          ></v-skeleton-loader>
        </div>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import i18n from '@/translations/lang'
import creditsApi from '@/services/creditsApi'

export default {
  name: 'CreditsInfo',
  components: {},
  props: {
    activationPrice: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    creditsLoading: false,
    errors: {
      unknownError: false,
      shownErrMsg: '',
      errMsg: i18n.t('message.errors.unexpectedError'),
    },
    accountBalance: 0,
    currency: 'brl',
    currencyLocale: 'pt-BR',
  }),
  computed: {},
  mounted() {
    this.loadCredits()
    this.setCurrencyConfig()
    this.$root.$on('reloadBalance', () => {
      this.getCreditsInfo()
    })
  },
  beforeDestroy() {
    this.$root.$off('reloadBalance')
  },
  methods: {
    async loadCredits() {
      this.creditsLoading = true
      await this.getCreditsInfo()
      this.creditsLoading = false
    },
    async getCreditsInfo() {
      try {
        const { data } = await creditsApi.getCreditsBalance()
        this.accountBalance = data.balance
        this.$root.$emit('balance', this.accountBalance)
      } catch (error) {
        console.error('error', error)
      }
    },
    setCurrencyConfig() {
      const currency = this.$store.state.user.userPlanInfo.currency
      if (currency === 'usd') {
        this.currency = 'usd'
        this.currencyLocale = 'en-US'
        return
      } else {
        this.currency = 'brl'
        this.currencyLocale = 'pt-BR'
      }
    },
    handleOpenCreditModal() {
      this.$root.$emit('creditsBuyModal')
    },
    handleGoToCreditDetails() {
      this.$router.push({ name: 'Credits' }).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.mainText {
  font-size: 14px;
  font-weight: 400;
  margin-top: 3px;
}
.buttonsText {
  font-size: 12px;
  font-weight: 500;
}

.textColor {
  color: #171924;
}
</style>
<style>
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}

.newSectionStyle {
  background-color: #ebedff;
  color: var(--v-primary-base);
  display: flex;
  border-radius: 24px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
